import {Tile} from "ol/layer";
import XYZ from "ol/source/XYZ";
import TileLayer from "ol/layer/Tile";
import LayerGroup from "ol/layer/Group";

export const esri_st_base = new TileLayer({
    title: 'Streets Basemap',
    type: 'base',
    visible: false,
    source: new XYZ({
        attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
            'rest/services/World_Street_Map/MapServer">ArcGIS</a>',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
            'World_Street_Map/MapServer/tile/{z}/{y}/{x}'
    })
});
export const azmaps_st_base = new TileLayer({
    title: 'Streets(Azure)',
    type: 'base',
    visible: false,
    source: new XYZ({
        url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.base.road&zoom={z}&x={x}&y={y}&clientId=${process.env.azmaps_client_id}&subscription-key=${process.env.azmaps_shared_key}`,
        maxZoom: 19
    })

});
export const azmaps_img_base = new TileLayer({
    title: 'Aerial(Azure)',
    type: 'base',
    visible: true,
    source: new XYZ({
        url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&clientId=${process.env.azmaps_client_id}&subscription-key=${process.env.azmaps_shared_key}`,
        maxZoom: 19
    })

});
export const esri_img_base = new LayerGroup({
    title: 'Aerial(ESRI)',
    type: 'base',
    combine: true,
    visible: false,
    layers: [
        new Tile({
            source: new XYZ({
                attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
                    'rest/services/World_Imagery/MapServer">ArcGIS</a>',
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                    'World_Imagery/MapServer/tile/{z}/{y}/{x}'
            })
        }),
        new Tile({
            source: new XYZ({
                attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
                    'rest/services/Reference/World_Transportation/MapServer">ArcGIS</a>',
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                    'Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}'
            })
        }),
        new Tile({
            source: new XYZ({
                attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
                    'rest/services/Reference/World_Boundaries_and_Places/MapServer">ArcGIS</a>',
                url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                    'Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}'
            })
        }),

    ]
});